import React from 'react';
import dayjs from 'dayjs';

import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import AddIcon from '@material-ui/icons/Add';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';

import { OutlineButton } from '../../_core/_ui/buttons.component';
import { IStoredDraft, draftLabel, draftPreview } from './compose-panel.drafts';

interface IDraftsListProps {
  drafts: IStoredDraft[];
  onOpen: (draft: IStoredDraft) => void;
  onDelete: (id: string) => void;
  onNewMessage: () => void;
}

export const DraftsList: React.FC<IDraftsListProps> = ({ drafts, onOpen, onDelete, onNewMessage }) => (
  <Box>
    <Box p={2} display="flex" justifyContent="flex-end">
      <OutlineButton size="small" startIcon={<AddIcon />} onClick={onNewMessage}>
        New message
      </OutlineButton>
    </Box>
    {drafts.length === 0 ? (
      <Box px={2} pb={3}>
        <Typography variant="body2" color="textSecondary">
          No saved drafts. Start composing and your message is saved here automatically.
        </Typography>
      </Box>
    ) : (
      <List disablePadding>
        {drafts.map((draft) => {
          const preview = draftPreview(draft.values);
          return (
            <ListItem key={draft.id} button divider alignItems="flex-start" onClick={() => onOpen(draft)}>
              <ListItemText
                primary={draftLabel(draft.values)}
                secondary={
                  <>
                    <Typography variant="caption" color="textSecondary" component="span" display="block">
                      {dayjs(draft.savedAt).format('MMM D, YYYY h:mm A')}
                    </Typography>
                    {preview && (
                      <Typography variant="caption" color="textSecondary" component="span" display="block">
                        {preview}
                      </Typography>
                    )}
                  </>
                }
              />
              <ListItemSecondaryAction>
                <IconButton
                  edge="end"
                  size="small"
                  aria-label="Delete draft"
                  onClick={() => onDelete(draft.id)}
                >
                  <DeleteOutlineIcon fontSize="small" />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          );
        })}
      </List>
    )}
  </Box>
);
